module.exports = __webpack_public_path__ + "assets/img/icon-truck-blue.decf0c88.png";